import { Badge } from '@ntconsult/aluma-react';
import {
  CalendarClock,
  CalendarX,
  CircleDot,
  Flag,
  Lock,
  type LucideIcon,
  Pause,
  PencilLine,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { Fase } from '../types/Progresso';

/** Tom e ícone por fase, para as fases se distinguirem sem ler (spec 28 R22). */
const VISUAL: Record<
  Fase,
  { tone: 'neutral' | 'danger' | 'info' | 'success' | 'brand' | 'warning'; Icone: LucideIcon }
> = {
  preparacao: { tone: 'neutral', Icone: PencilLine },
  vencida: { tone: 'danger', Icone: CalendarX },
  agendada: { tone: 'info', Icone: CalendarClock },
  aberta: { tone: 'success', Icone: CircleDot },
  encerrada: { tone: 'brand', Icone: Flag },
  pausada: { tone: 'warning', Icone: Pause },
  fechada: { tone: 'neutral', Icone: Lock },
};

export function FaseBadge({ fase }: { fase: Fase }) {
  const { t } = useTranslation('campanhas');
  const { tone, Icone } = VISUAL[fase];
  return (
    <Badge tone={tone} icon={<Icone aria-hidden className="size-3.5" />} data-fase={fase}>
      {t(`fases.${fase}`)}
    </Badge>
  );
}
